export function useApp() {
  return {
    isDebug: import.meta.env.VITE_DEBUG === 'true',
    version: GIT_VERSION,
  }
}
